import { useEffect, useState } from 'react';

import { PreferencesParam } from 'src/enums/PreferencesParam';
import i18n from 'src/i18n';
import { preferencesService } from 'src/services/preferences/preferencesService';
import { useBoundStore } from 'src/store/store';

export function usePreferences(): {
  sidebar: boolean;
  setSidebar: (sidebar: boolean) => void;
  language: string;
  setLanguage: (language: string) => void;
} {
  const [sidebar, setSidebar] = useState(
    preferencesService.get(PreferencesParam.SIDEBAR_CLOSE) as boolean,
  );

  const { language, setLanguage: setLanguageStore } = useBoundStore(
    (state) => state,
  );

  const setLanguage = (language: string) => {
    setLanguageStore(language);
    preferencesService.set(PreferencesParam.LANGUAGE, language);
    i18n.changeLanguage(language);
  };

  useEffect(() => {
    preferencesService.set(PreferencesParam.SIDEBAR_CLOSE, sidebar);
  }, [sidebar]);

  return {
    sidebar,
    setSidebar,
    language,
    setLanguage,
  };
}
